

import { mapState } from 'vuex'
import { mdiDelete } from '@mdi/js'
import time from '@/components/tools/time'
import AddToRemoveFromWatchlist from '@/components/catalog/AddToRemoveFromWatchlist'
import AuctionStatusChip from '@/components/catalog/chips/AuctionStatusChip'
import BuyNowProductChip from '@/components/catalog/chips/BuyNowProductChip'

export default {
  components: {
    BuyNowProductChip,
    AuctionStatusChip,
    AddToRemoveFromWatchlist
  },
  props: {
    product: {
      type: Object,
      required: true
    },
    withWatchlistIcon: {
      type: Boolean,
      default: true
    },
    aspectRatio: {
      type: Number,
      default: 16 / 9
    },
    withWatchlistTrashIcon: {
      type: Boolean,
      default: false
    },
    removeRefreshCallback: {
      type: Function,
      default: () => {
      }
    }
  },
  data () {
    return {
      mdiDelete
    }
  },
  computed: {
    ...mapState('customer', {
      customerId: state => state.customer.customerId,
      merchantAcceptedByCm24: state => state.merchant.acceptedByCm24 === true
    }),
    isOwner () {
      if (this.customerId) {
        return this.product?.customerId === this.customerId
      }
      return false
    },
    style () {
      return ['sold', 'failed'].includes(this.product?.auction?.status) ? 'opacity: 0.5' : ''
    },
    isWatchlistButtonDisabled () {
      const { context, customerId } = this.product

      if (context?.holdingHighestBid || this.customerId === customerId) {
        return true
      }
      return false

      // if (this.product?.auction?.status === 'acpt_late_offer') {
      //   return false
      // }
      //
      // const { context, customerId } = this.product
      //
      // return ![undefined, null].includes(context?.holdingHighestBid) || this.customerId === customerId
    },
    isOnWatchList () {
      return this.product.context?.watchlist
    },
    endingAt () {
      return time.parseDate(this.product.auction?.endingAt)
    },
    isBuyNowChipShown () {
      const { buyNowEnabled, buyNowPrice, hasBids, status } = this.product.auction ?? {}

      return buyNowEnabled && buyNowPrice !== null && !hasBids && status === 'running'
    },
    alt () {
      return this.product.title
    },
    hasBiddingContext () {
      return !(this.product?.context?.holdingHighestBid === undefined || this.product?.context?.holdingHighestBid === null)
    },
    withWatchlistTrashIconForThisProduct () {
      if (this.$auth.loggedIn === false) {
        return false
      }

      if (!this.hasBiddingContext && this.withWatchlistTrashIcon) {
        return true
      }
      return this.withWatchlistIcon
    }
  },
  methods: {
    getImage (quality) {
      const width = 700
      const aspectRatio = 4 / 3
      const height = width / aspectRatio
      const background = '#f1f1f1'

      if (!this.product.image) {
        return this.$img('placeholder.png', { width, height, quality, background }, { provider: 'imagekit' })
      }

      return this.$img(this.product.image, { width, height, quality }, { provider: 'imagekit' })
    }
  }
}
